<template>
    <div class="form-group mod">
        <div style="position: relative;">
            <input
                type="text"
                class="form-control"
                :id="id"
                :placeholder="placeholder"
                :autocomplete="autocomplete"
                v-model="componentValue"
                @input="doInput"
                @blur="doBlur"
                :disabled="disabled"
            />
            <div v-if="!hideIcon" class="input-search" @click="doSearch">
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M12.5 11H11.71L11.43 10.73C12.41 9.59 13 8.11 13 6.5C13 2.91 10.09 0 6.5 0C2.91 0 0 2.91 0 6.5C0 10.09 2.91 13 6.5 13C8.11 13 9.59 12.41 10.73 11.43L11 11.71V12.5L16 17.49L17.49 16L12.5 11ZM6.5 11C4.01 11 2 8.99 2 6.5C2 4.01 4.01 2 6.5 2C8.99 2 11 4.01 11 6.5C11 8.99 8.99 11 6.5 11Z"
                        fill="#C8D0DD"
                    />
                </svg>
            </div>
            <div v-if="clearable && componentValue" id="clear__input" class="position-absolute" @click="clearText()">
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M0.292893 0.292893C0.683417 -0.0976311 1.31658 -0.0976311 1.70711 0.292893L7 5.58579L12.2929 0.292893C12.6834 -0.0976311 13.3166 -0.0976311 13.7071 0.292893C14.0976 0.683417 14.0976 1.31658 13.7071 1.70711L8.41421 7L13.7071 12.2929C14.0976 12.6834 14.0976 13.3166 13.7071 13.7071C13.3166 14.0976 12.6834 14.0976 12.2929 13.7071L7 8.41421L1.70711 13.7071C1.31658 14.0976 0.683417 14.0976 0.292893 13.7071C-0.0976311 13.3166 -0.0976311 12.6834 0.292893 12.2929L5.58579 7L0.292893 1.70711C-0.0976311 1.31658 -0.0976311 0.683417 0.292893 0.292893Z" fill="#6F7287"/>
                </svg>
            </div>
        </div>
    </div>
</template>

<script>
import { regex } from "@/store/utils/vars";

export default {
    name: "SOInputSearch",
    props: {
        id: {
            type: String,
            required: true,
        },
        placeholder: {
            type: String,
            default: "Cari...",
        },
        value: {
            type: String,
            default: "",
        },
        autocomplete: {
            type: String,
            default: "off", // on || off
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        doSearching: {
            type: Function,
            required: true,
        },
        delayTime: {
            type: Number,
            default: 1000,
        },
        hideIcon: {
            type: Boolean,
            default: false,
        },
        clearable: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            componentValue: "",
            regexType: {
                default: regex.default,
                alphanumeric: regex.alphanumeric,
                email: regex.email,
                emoji: regex.emoji,
            },
        };
    },
    watch: {
        value: {
            handler: function() {
                this.doRegex();
            },
        },
    },
    mounted() {
        this.doRegex();
    },
    methods: {
        doRegex() {
            if (this.validation === "") {
                this.validation = "alphanumeric";
            }
            let regexType = this.regexType[this.validation];
            this.componentValue = this.value.replace(regexType, "");
            this.componentValue = this.componentValue.replace(this.regexType.emoji, "");
            if (this.uppercase) {
                this.componentValue = this.componentValue.toUpperCase();
            }

            this.$emit("input", this.componentValue);
        },
        doInput(val) {
            let that = this;
            clearTimeout(this.debounce);
            this.debounce = setTimeout(() => {
                let value = val.target.value;

                that.$emit("input", value);
                that.doSearching(value);
            }, this.delayTime);
        },
        doSearch() {
            this.doSearching(this.componentValue);
        },
        doBlur() {
            this.$emit("blur");
        },
        clearText() {
            this.componentValue = null
            this.$emit('input', this.componentValue)
            this.$emit('clear')
        }
    },
};
</script>
<style scoped>
.input-search {
    width: 30px;
    height: 30px;
    position: absolute;
    top: 12px;
    right: 4px;
}
#clear__input {
    top: 10px;
    right: 24px;
}
</style>
